import React,{Component} from 'react';
import PropTypes from 'prop-types'
import Product from '../../Shared/Product';
import AutoSSL from '../../Shared/AutoSSL';
import Popover from '../../Shared/Popover';

class PersonalSecurePlans extends Component{
    render(){
        const {parent,data} = this.props;
        let wildcardssl = null;
        if(data && data.length>0 && parent.pids){
            data.forEach((item)=>{
                if(item.whmcs_id=== parent.pids[3]){
                    wildcardssl = item;
                }
            });
        }
        return(
            <div className={`SSL-Selector__Page SSL-Selector__Page--PersonalSecurePlans`}>
                <div className={`SSL-Selector__description clearfix`}>Perfect for business that uses <Popover />.</div>
                <div className={`SSL-Selector__Productfit clearfix`}>
                    {data && data.length>0 && data[3]? <Product productdetails={wildcardssl||data[3]}/>: ''}
                </div>
                <div className={`clear`}></div>
                <div className={`SSL-Selector__link`} onClick={parent.resetAll}>Start Over</div>
                <div className={`clear`}></div>
                <AutoSSL />
            </div>
        )
    }
}
PersonalSecurePlans.propTypes ={
  parent: PropTypes.object,
  data: PropTypes.object
}
export default PersonalSecurePlans;